import { CircularProgress, Stack } from '@mui/material';
import * as React from 'react';

interface Props {
    isLoading?: boolean;
    children?: React.ReactNode;
}

export default function Loader({ isLoading, children }: Props) {
    if (!isLoading) return <>{children}</>;

    return (
        <Stack alignItems="center" justifyContent="center" flex={1}>
            <CircularProgress color="primary" />
        </Stack>
    );
}
